module.exports = __webpack_public_path__ + "img/16.95a39a39.jpg";